<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="cuenta != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Deseas intentar facturar la cuenta?</span>
                        </div>
                    </div>
                    <div class="row doc-note-error">
                        <p class="doc-note__title-error">Error de facturación</p><br>
                        <p class="">{{ cuenta.error }}
                        </p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CERRAR" @click="dialogConfirmacion = false" />
                    <q-btn label="Aceptar" color="primary" @click="FacturaErroneas()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md" style="height: 100%; overflow-y: auto;">
            <div class="col-12">
                <q-table dense title="Cuentas Pendientes por Facturar" class="shadow-1" :data="dataList"
                    :loading="loading" :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>

                        <q-select outlined v-model="tipo" :options="tipos" label="Tipo de Factura"
                            class="q-my-md q-mr-sm" option-label="label" option-value="value" dense required emit-value
                            map-options style="width: 200px;" />

                        <q-select outlined v-model="estado" :options="estados" label="Estatus" class="q-my-md" dense
                            required emit-value option-value="value" map-options style="width: 200px;" />

                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar"
                            @click="GetListaErroresFacturas()" no-caps class="q-ml-sm q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="uuid" :props="props" @click="verItem(props.row)">{{ props.row.uuid }}</q-td>
                            <q-td key="estado" :props="props" @click="verItem(props.row)">{{ props.row.estado
                            }}</q-td>
                            <q-td key="fechacreacion" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechacreacion) }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{ props.row.tipo ?
                                props.row.tipo.toUpperCase() : ''
                                }}</q-td>
                            <q-td key="nombre" :props="props" @click="verItem(props.row)">{{
                                props.row.nombre }}</q-td>
                            <q-td key="procedencia" :props="props" @click="verItem(props.row)">{{
                                props.row.procedencia }}</q-td>
                            <q-td key="concepto" :props="props" @click="verItem(props.row)">{{
                                props.row.concepto }}</q-td>
                            <q-td key="monto" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.monto) }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";
import moment from 'moment';
export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            loading: false,
            dataList: [],
            columns: [
                { name: 'uuid', label: 'UUID', field: 'uuid', align: 'center', sortable: true },
                { name: 'estado', label: 'Estado', field: 'estado', align: 'center', sortable: true },
                { name: 'fechacreacion', label: 'Fecha de Creación', field: 'fechacreacion', align: 'right', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'nombre', label: 'Cliente', field: 'nombre', align: 'left', sortable: true },
                { name: 'procedencia', label: 'Procedencia', field: 'procedencia', align: 'center', sortable: true },
                { name: 'concepto', label: 'Concepto', field: 'concepto', align: 'left', sortable: true },
                { name: 'monto', label: 'Monto', field: 'monto', align: 'right', sortable: true },
            ],

            tipos: [
                { label: 'Factura', value: 'F' },
                { label: 'Complementos de Pago', value: 'P' }
            ],

            estados: [
                { label: 'Facturado', value: 'Vigente' },
                { label: 'Pendiente', value: 'Error' },
            ],

            tipo: 'F',
            estado: 'Error',

            initialPagination: {
                sortBy: 'modelo',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogConfirmacion: false,
            cuenta: null
        }
    },
    async mounted() {
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
    },
    methods: {
        async verItem(item) {
            console.log(item)
            if (item.estado == 'Error') {
                this.cuenta = item
                this.dialogConfirmacion = true
            }

        },

        async GetListaErroresFacturas() {
            this.loading = true
            try {
                let respuesa = await axios.get('Facturas/GetListaErroresFacturas/' + this.tipo + '/' + this.estado)
                console.log(respuesa)
                this.loading = false

                this.dataList = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        async FacturaErroneas() {

            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Facturando. Espere...', messageColor: 'white' })
            const objeto = {
                id: this.cuenta._id
            }
            try {
                let respuesa = await axios.post('Facturas/FacturaErroneas/', objeto)
                console.log(respuesa)
                this.$q.loading.hide()
                if (respuesa.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se facturo correctamente la cuenta pendiente por facturar.` });
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: respuesa.data.mensaje });
                }
                this.GetListaErroresFacturas()
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al facturar, corrija los errores e intentelo de nuevo.` });

            }
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note-error {
    background-color: #ffb9b9;
    /* Fondo claro */
    border-left: 4px solid #db243f;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title-error {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #db243f;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>